import React from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { strapi_end_point } from '../config';
import { useEffect, useState, useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper';
import 'swiper/css';
import 'swiper/css/autoplay';
const qs = require('qs');
import bitsDefault from '../images/Default-Bits.jpg';
import filterBitsIcon from '../images/filterIcon.svg';
import useElementOnScreen from "../hooks/useElementOnScreen";
import { getJwt, getUser, GetOptimizeImage } from '../utils/handle-session';
export default function PersonalisedSection() {
	const options = {
		root: null,
		rootMargin: "0px",
		threshold: 0.3,
	};
	const videoRef = useRef(null);
	const isVisibile = useElementOnScreen(options, videoRef);
	const [openTab, setOpenTab] = useState(1);
	const [PlayVid, setPlayVid] = useState(false);
	const [isLoading, setLoading] = useState(true);
	const [randomBits, setRandomBits] = useState([]);
	const [recommd, setRecommd] = useState([]);
	const [trendingBits, setTrendingBits] = useState([]);
	const GetData = async () => {
		// await GetRecommD();
		const user = getUser();
		const jwt = getJwt();
		var obj = {
			sort: ['id:desc'],
			fields: ['id'],
			populate: {
				bits_content: {
					fields: ['id', 'caption', 'title', 'slug'],
					populate: {
						video: '*',
						videos: '*',
						cover: '*',
					},
				},
			},
			pagination: {
				pageSize: 25,
				page: 1,
			},
			publicationState: 'live',
			locale: ['en'],
		};
		var query = qs.stringify(obj, {
			encodeValuesOnly: true, // prettify url
		});
		var res = await fetch(`${strapi_end_point}/api/bits-randoms?${query}`);
		var resDecode = await res.json();
		setRandomBits(resDecode.data);
		var obj = {
			sort: ['id:desc'],
			fields: ['id'],
			populate: {
				bits_content: {
					fields: ['id', 'caption', 'title', 'slug'],
					populate: {
						video: '*',
						videos: '*',
						cover: '*',
					},
				},
			},
			pagination: {
				pageSize: 25,
				page: 1,
			},
			publicationState: 'live',
			locale: ['en'],
		};
		var query = qs.stringify(obj, {
			encodeValuesOnly: true, // prettify url
		});
		var res = await fetch(`${strapi_end_point}/api/bits-views?${query}`);
		var resDecode = await res.json();
		var sortbits = [];
		resDecode.data.map((bit) => {
			if (bit.attributes.bits_content.data !== null) {
				sortbits.push(bit.attributes.bits_content.data);
			}
		});
		const groupByCategory = sortbits.reduce((group, product) => {
			const { id } = product;
			group[id] = group[id] ?? [];
			group[id].push(product);
			return group;
		}, {});
		setTrendingBits(groupByCategory);
		setLoading(false);

	};
	useEffect(() => {
		GetData();
	}, []);

	const GetRecommD = async (id) => {
		try {
			var bitsContents = Array();
			const user = getUser();
			const jwt = getJwt();
			// const for_you = localStorage.getItem('for_you');
			// if(for_you==""){

			// }else{
			// 	var decodeData = JSON.parse(for_you)

			// }
			if (user && jwt) {
				let userdata = JSON.parse(user);
				var dataRequest = await fetch("https://learning-369407.de.r.appspot.com/bits/" + userdata.id);
			} else {
				var dataRequest = await fetch("https://learning-369407.de.r.appspot.com/popular");
			}

			var decodeData = await dataRequest.json();

			localStorage.setItem('for_you', JSON.stringify(decodeData.data));

			for (var key in decodeData.data) {
				if (key > 10) {
					break;
				}
				var obj = {
					fields: ['id', 'caption', 'title', 'slug'],
					populate: {
						video: '*',
						videos: '*',
						cover: '*',
					},
					publicationState: 'live',
					locale: ['en'],
				};
				var query = qs.stringify(obj, {
					encodeValuesOnly: true, // prettify url
				});
				var res = await fetch(`${strapi_end_point}/api/bits-contents/${decodeData.data[key]}?${query}`);
				var resDecode = await res.json();
				bitsContents.push(resDecode.data);
			}
			setRecommd(bitsContents);
			console.log(bitsContents);
		} catch (e) {
			console.error(e);
		}
	}

	useEffect(() => {
		if (isVisibile) {
			videoRef.current.play();
		} else {
			if (videoRef.current) {
				videoRef.current.pause();
			}
		}
	}, [isVisibile]);
	const myLoader = ({ src }) => {
		return `${src}`;
	};
	return (
		<div className="subject-list mb-9 bittabs-container">
			<div className="flex justify-between">
				<ul className="flex mb-6">
					<li>
						<a
							className={
								openTab === 1
									? 'text-white font-medium md:text-2xl sm:text-xl text-sm inline-block relative after:bg-primary after:h-[2px] after:w-[50px] after:absolute after:left-0 after:bottom-0'
									: 'text-white font-medium md:text-2xl sm:text-xl text-sm inline-block'
							}
							onClick={(e) => {
								e.preventDefault();
								setOpenTab(1);
							}}
							data-toggle="tab"
							href="#link1"
							role="tablist">
							For You
						</a>
					</li>
					<li className="lg:px-12 md:px-9 px-3">
						<a
							className={
								openTab === 2
									? 'text-white font-medium md:text-2xl sm:text-xl text-sm inline-block relative after:bg-primary after:h-[2px] after:w-[50px] after:absolute after:left-0 after:bottom-0'
									: 'text-white font-medium md:text-2xl sm:text-xl text-sm inline-block'
							}
							onClick={(e) => {
								e.preventDefault();
								setOpenTab(2);
							}}
							data-toggle="tab"
							href="#link2"
							role="tablist">
							Trending
						</a>
					</li>
				</ul>
				<Link href="/personalize" passHref>
					<a className="text-white font-medium md:text-2xl sm:text-xl text-sm inline-block">
						<Image src={filterBitsIcon} width={27} height={18} alt="" />
					</a>
				</Link>
			</div>

			<div className="bitstab-content">
				<div className={openTab === 1 ? 'block sm:-mx-3 -mx-1' : 'hidden'} id="link1">
					<Swiper
						slidesPerView={4.5}
						breakpoints={{
							320: {
								slidesPerView: 2.3,
							},
							768: {
								slidesPerView: 3.5,
							},
							1024: {
								slidesPerView: 4.5,
							},
						}}>
						{!isLoading ? (
							recommd.length > 0 ? recommd.map((bit, index) => {
								if (bit == null) {
									return false;
								}
								let Images = bit.attributes.cover.data ? GetOptimizeImage(bit.attributes.cover.data.attributes) : null;
								return (
									<SwiperSlide key={index}>
										<div className="sm:px-3 px-1">
											<div className="rounded-xl mb-6 relative courser-list">
												<div className="relative">
													<Link href={`/bits/for-you?episode=${index + 1}`}>
														<a>
															<div className="absolute inset-0 z-[-1]">
																<Image loader={myLoader} src={`${Images ? Images : bitsDefault.src}`} layout='fill' objectFit='cover' alt="" className="loader-img rounded-xl" />
															</div>
															<video
																preLoad="none"
																onMouseEnter={(e) => {
																	e.currentTarget.play();
																}}
																onMouseLeave={(e) => {
																	e.currentTarget.pause();
																}}
																//poster={`${Images ? Images : bitsDefault.src}`}
																loop
																muted
																autoPlay={false}
																id={"videoRand_" + index}
																ref={index == 0 ? videoRef : undefined}
																className="rounded-xl sm:h-[370px] h-[270px] w-full">
																<source
																	src={`${bit.attributes.videos.data != null ? bit.attributes.videos.data[0].attributes.url : bit.attributes.video.data.attributes.url}`}
																/>
															</video>
														</a>
													</Link>
												</div>
											</div>
										</div>
									</SwiperSlide>
								);
							}) : randomBits.map((bit, index) => {
								if (bit.attributes.bits_content.data == null) {
									return false;
								}
								let Images = bit.attributes.bits_content.data.attributes.cover.data ? GetOptimizeImage(bit.attributes.bits_content.data.attributes.cover.data.attributes) : null;
								return (
									<SwiperSlide key={index}>
										<div className="sm:px-3 px-1">
											<div className="rounded-xl mb-6 relative courser-list">
												<div className="relative">
													<Link href={`/bit/${bit.attributes.bits_content.data.attributes.slug}`}>
														<a>
															<div className="absolute inset-0 z-[-1]">
																<Image loader={myLoader} src={`${Images ? Images : bitsDefault.src}`} layout='fill' objectFit='cover' alt="" className="loader-img rounded-xl" />
															</div>
															<video
																preLoad="none"
																onMouseEnter={(e) => {
																	e.currentTarget.play();
																}}
																onMouseLeave={(e) => {
																	e.currentTarget.pause();
																}}
																//poster={`${Images ? Images : bitsDefault.src}`}
																loop
																muted
																autoPlay={false}
																id={"videoRand_" + index}
																ref={index == 0 ? videoRef : undefined}
																className="rounded-xl sm:h-[370px] h-[270px] w-full">
																<source
																	src={`${bit.attributes.bits_content.data.attributes.videos.data != null ? bit.attributes.bits_content.data.attributes.videos.data[0].attributes.url : bit.attributes.bits_content.data.attributes.video.data.attributes.url}`}
																/>
															</video>
														</a>
													</Link>
												</div>
											</div>
										</div>
									</SwiperSlide>
								);
							})
						) : (
							<center>
								<a className="play-btn cursor-pointer rounded-full h-12 w-12 md:h-16 md:w-16 flex justify-center items-center">
									<i className="fas fa-spinner fa-spin text-xl text-white"></i>
								</a>
							</center>
						)}
					</Swiper>
				</div>
				<div className={openTab === 2 ? 'block sm:-mx-3 -mx-1' : 'hidden'} id="link2">
					<Swiper
						slidesPerView={4.5}
						breakpoints={{
							320: {
								slidesPerView: 2.3,
							},
							768: {
								slidesPerView: 3.5,
							},
							1024: {
								slidesPerView: 4.5,
							},
						}}>
						{!isLoading ? (
							Object.keys(trendingBits).map((bit, index) => {
								let Images = trendingBits[bit][0].attributes.cover.data ? GetOptimizeImage(trendingBits[bit][0].attributes.cover.data.attributes) : null;
								return (
									<SwiperSlide key={index}>
										<div className="sm:px-3 px-1">
											<div className="rounded-xl mb-6 relative courser-list">
												<div className="relative">
													<Link href={`/bit/${trendingBits[bit][0].attributes.slug}`}>
														<a>
															<div className="absolute inset-0 z-[-1]">
																<Image loader={myLoader} src={`${Images ? Images : bitsDefault.src}`} layout='fill' objectFit='cover' alt="" className="loader-img rounded-xl" />
															</div>
															<video
																preLoad="none"
																onMouseEnter={(e) => {
																	e.currentTarget.play();
																}}
																onMouseLeave={(e) => {
																	e.currentTarget.pause();
																}}
																//poster={`${Images ? Images : bitsDefault.src}`}
																loop
																autoPlay={index == 0 ? false : false}
																muted
																className="rounded-xl sm:h-[370px] h-[270px] w-full">
																<source
																	src={trendingBits[bit][0].attributes.videos.data != null ? trendingBits[bit][0].attributes.videos.data[0].attributes.url : trendingBits[bit][0].attributes.video.data.attributes.url}
																	type={trendingBits[bit][0].attributes.video.data.attributes.mime}
																/>
															</video>
														</a>
													</Link>
												</div>
											</div>
										</div>
									</SwiperSlide>
								);
							})
						) : (
							<center>
								<a className="play-btn cursor-pointer rounded-full h-12 w-12 md:h-16 md:w-16 flex justify-center items-center">
									<i className="fas fa-spinner fa-spin text-xl text-white"></i>
								</a>
							</center>
						)}
					</Swiper>
				</div>
			</div>
		</div>
	);
}